import { createEvent, sample, split } from "effector";
import { $playerCurrentTrackSource, resetPlayerCurrentTrackIndexAndTrackSourceIndex, setPlayerTrackQueue, } from "frontend/src/domain/player-track-queue";
import { createLoadTracksForCurrentTrackSourceModel } from "frontend/src/features/load-player-tracks-source";
import { playCurrentTrackInQueueAttempted } from "frontend/src/features/play-track-from-queue";
import { notify } from "../notifications";
import { deactivateWebSchedule } from "frontend/src/features/play-web-schedule";
var _a = createLoadTracksForCurrentTrackSourceModel(), loadPlayerCurrentTracksSourceAttempted = _a.loadPlayerCurrentTracksSourceAttempted, tracksLoadedAndSet = _a.tracksLoadedAndSet;
export var playTodayTimetableAttempted = createEvent();
var timetableHasNoTracks = createEvent();
sample({
    clock: playTodayTimetableAttempted,
    target: deactivateWebSchedule,
});
sample({
    clock: playTodayTimetableAttempted,
    fn: function (_a) {
        var id = _a.id, title = _a.title;
        return ({
            type: "today_timetable",
            attributes: {
                id: id,
                title: title,
            },
            tracks: [],
        });
    },
    target: setPlayerTrackQueue,
});
sample({
    clock: playTodayTimetableAttempted,
    target: [
        resetPlayerCurrentTrackIndexAndTrackSourceIndex,
        loadPlayerCurrentTracksSourceAttempted,
    ],
});
split({
    source: sample({
        clock: tracksLoadedAndSet,
        source: $playerCurrentTrackSource,
        fn: function (trackSource) { return trackSource; },
    }),
    match: {
        loadedTimetableHasTracks: function (trackSource) {
            return trackSource !== null && trackSource.tracks.length > 0;
        },
    },
    cases: {
        loadedTimetableHasTracks: playCurrentTrackInQueueAttempted,
        __: timetableHasNoTracks,
    },
});
sample({
    clock: timetableHasNoTracks,
    source: playTodayTimetableAttempted,
    fn: function (_a) {
        var title = _a.title;
        return title;
    },
    target: notify.prepend(function (title) { return ({
        variant: "error",
        message: "\u0412 \u0441\u0435\u0442\u043A\u0435 \u0432\u0435\u0449\u0430\u043D\u0438\u044F \"" + title + "\" \u043D\u0435\u0442 \u0442\u0440\u0435\u043A\u043E\u0432.",
    }); }),
});
